function Home() {
  return (
    <div style={{ textAlign: "center", paddingTop: "6rem", paddingBottom: "5rem" }}>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          backgroundColor: "hsl(220, 25%, 95%)",
          color: "#0049ff",
          fontSize: "0.875rem",
          fontWeight: 500,
          borderRadius: "9999px",
          padding: "0.5rem 1rem",
          marginBottom: "2rem",
        }}
      >
        <i className="bi bi-binoculars"></i>
        Colibry Watchtower
      </div>

      <h1
        style={{
          fontSize: "clamp(2rem, 5vw, 3.5rem)",
          fontWeight: 700,
          color: "hsl(220, 30%, 15%)",
          marginBottom: "1.5rem",
          letterSpacing: "-0.025em",
          lineHeight: 1.1,
        }}
      >
        Jouw automations
        <br />
        <span
          style={{
            background: "linear-gradient(135deg, #0049ff 0%, hsl(235, 85%, 55%) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          monitoren en beheren
        </span>
      </h1>

      <p
        style={{
          maxWidth: "600px",
          margin: "0 auto 2.5rem",
          color: "hsl(220, 15%, 45%)",
          fontSize: "1.125rem",
          lineHeight: 1.7,
        }}
      >
        Colibry ontwikkelt een platform waarmee je volledige controle krijgt over je communicatie en automatisaties. Je
        kan zelf workflows configureren, mailtemplates beheren en met behulp van AI het maximale halen uit je
        klantendatabase en dagelijkse werking.
        <br />
        <br />
        Dit nieuwe platform bevindt zich momenteel in beta en wordt actief getest. Voor meer informatie kan je terecht
        bij{" "}
        <a href="mailto:support@colibry.ai" style={{ color: "#0049ff", textDecoration: "none", fontWeight: 500 }}>
          support@colibry.ai
        </a>{" "}
        of bezoek onze website.
      </p>

      <a
        href="https://colibry.ai"
        target="_self"
        rel="noopener noreferrer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          background: "linear-gradient(135deg, #0049ff 0%, hsl(235, 85%, 55%) 100%)",
          color: "#fff",
          fontWeight: 600,
          fontSize: "1rem",
          padding: "0.75rem 2rem",
          borderRadius: "0.75rem",
          textDecoration: "none",
          boxShadow: "0 4px 14px 0 hsl(223, 100%, 50%, 0.35)",
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
        }}
      >
        Ga naar Colibry <i className="bi bi-arrow-right-short" style={{ fontSize: "1.25rem" }}></i>
      </a>
    </div>
  );
}

export default Home;
